export function getDeclension(number: number, forms: [string, string, string]): string {
    const mod10 = number % 10;
    const mod100 = number % 100;

    if (mod10 === 1 && mod100 !== 11) {
        return `${number} ${forms[0]}`; // Например: 1 магазине
    } else if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) {
        return `${number} ${forms[1]}`; // Например: 2 магазина
    } else {
        return `${number} ${forms[2]}`; // Например: 5 магазинов
    }
}

export function getProductCountDescription(count: number): string {
    if (count <= 2) {
        return "мало";
    } else if (count > 2 && count <= 10) {
        return "достаточно";
    } else if (count > 10) {
        return "много";
    } else {
        return `${count}`;
    }
}